import React, { createContext } from 'react';
import { FormControllerProvider } from '../../../../../../helpers/formManager';

const EmptySubmitContext = createContext();
const EmptyModalPropsContext = createContext();

const submitValue = { loading: false, onSubmit: () => {} };

const EmptyProvider = ({ children }) => {
  return (
    <EmptySubmitContext.Provider value={submitValue}>
      <FormControllerProvider>
        <EmptyModalPropsContext.Provider>
          {children}
        </EmptyModalPropsContext.Provider>
      </FormControllerProvider>
    </EmptySubmitContext.Provider>
  );
};

const EmptyStrategy = {
  Provider: EmptyProvider,
  SubmitContext: EmptySubmitContext,
  ModalPropsContext: EmptyModalPropsContext,
  fields: null,
};

export default EmptyStrategy;
